import React, { useState, useEffect } from "react";
import { Select, Input, Form, Switch, Spin } from "antd";
import columns from "../../columns/AccountType.js";
import Pagination from "../../components/global/pagination/Pagination.jsx";
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import ModalComponent from "../../components/global/modal/ModalComponent.jsx";
import TableWithSkeleton from "../../components/global/table/TableWithSkeleton.jsx";
import { GetAllPlansApi, GetPlanByIdApi, GetAllGroupListApi, AddUpdatePlanApi, UpdatePlanStatusApi, SyncGroupsApi, GetGroupDetaisApi, CreateGroupApi, GetGroupPlanNameApi } from "../../api/request/accountType.js";
import moment from "moment";
import toast from "react-hot-toast";
import Edit from "../../assets/Edit.jsx";
import Eye from "../../assets/Eye.jsx";
import ConfirmationModal from "../../components/global/modal/ConfirmationModal.jsx";

export default function AccountType() {
  const [form] = Form.useForm();
  const [createGroupForm] = Form.useForm();
  const [pageSize, setPageSize] = useState(10);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPlandetailsLoading, setIsPlandetailsLoading] = useState(false);
  const [isOpenPlanModal, setIsOpenPlanModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [activePlanDetails, setActivePlanDetails] = useState({});
  const [initialValues, setInitialValues] = useState({ planName: '', groupId: null, minimumDeposit: '', instruments: '', spread: '', commission: '', groupCommission: null, v2fx: null, swapFree: null, marginCall: '', stopOut: '', tradingAccountType: null, isActive: true });
  const [groups, setGroups] = useState([]);
  const [groupPlanName, setGroupPlanName] = useState([]);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isFormChanged, setIsFormChanged] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState('');
  const [groupCommissionOptions, setGroupCommissionOptions] = useState([]);
  const [isStatusConfirmOpen, setIsStatusConfirmOpen] = useState(false);
  const [isStatusConfirmLoading, setIsStatusConfirmLoading] = useState(false);
  const [isSync, setIsSync] = useState(false)
  const [openCreateGroupModal, setOpenCreateGroupModal] = useState(false);
  const [createGroupInitValues, setCreateGroupInitValues] = useState({ name: '', userName: '', email: '', password: '', isReadOnly: true, phone: '', address: '', forceChangePassword: true });

  const handleFieldsChange = (_, allFields) => {
    setSelectedGroupId(allFields[1]?.value);
    const isChanged = allFields.some(field => field.touched);
    setIsFormChanged(isChanged);
  };

  const getGroupDetais = async () => {
    try {
      const selectedGroup = groups.find((item) => item?.groupId == selectedGroupId);

      const { data } = await GetGroupDetaisApi(selectedGroupId);
      if (data?.success) {
        if (selectedGroup?.groupCommission) {
          setGroupCommissionOptions(
            data?.data?.groupCommission?.map((item) => ({
              value: item?.groupCommissions,
              label: item?.name + ' ' + item?.groupCommissions,
            }))
          );
        }
        form.setFieldsValue({
          marginCall: data?.data?.marginCallLevel,
          stopOut: data?.data?.stopOutLevel,
          // instruments: data?.data?.instruments,
          // spread: data?.data?.spread,
          groupCommission: null
        });
      }
    } catch (error) { }
  }

  useEffect(() => {
    if (selectedGroupId) {
      form.setFieldsValue({
        groupCommission: null,
      });
      getGroupDetais();
    }
  }, [selectedGroupId]);

  const getAllPlan = async () => {
    try {
      let params = {
        PageNumber: page,
        PageSize: pageSize,
      }
      setIsLoading(true);
      const { data } = await GetAllPlansApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              swapFree: (item?.swapFree ? (<p>Yes</p>) : (<p>No</p>)),
              minimumDeposit: `$ ${item?.minimumDeposit}`,
              commission: `$ ${item?.commission}`,
              groupCommission: `$ ${item?.groupCommission}`,
              createdDate: item?.createdDate ? moment(item?.createdDate).format('DD-MM-YYYY, hh:mm A') : null,
              status: (<Switch onChange={() => statusHandler(item)} checkedChildren="On" unCheckedChildren="Off" checked={item?.isActive} />),
              actions: (
                <div className="flex gap-3">
                  <button onClick={() => { setSelectedPlan(item); updatePlanHandler(item) }}><Edit /></button>
                  <button type="button" onClick={() => { setIsOpenModal(true); setSelectedPlan(item); }}><Eye /></button>
                </div>
              ),
            };
          })
        );
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  const statusChangeConfirm = async () => {
    try {
      setIsStatusConfirmLoading(true);
      let params = {
        planId: selectedPlan?.planId,
        isActive: !selectedPlan?.isActive
      }
      const { data } = await UpdatePlanStatusApi(params);
      if (data?.success) {
        getAllPlan();
        toast.success(data?.message);
        setIsStatusConfirmOpen(false);
      }
      setIsStatusConfirmLoading(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsStatusConfirmLoading(false);
    }
  }

  const statusHandler = async (plan) => {
    setSelectedPlan(plan);
    setIsStatusConfirmOpen(true);
  }

  const getActivePlan = async () => {
    try {
      setIsPlandetailsLoading(true);
      const { data } = await GetPlanByIdApi(selectedPlan?.planId);
      if (data?.success) {
        setActivePlanDetails(data?.data)
      }
      setIsPlandetailsLoading(false);
    } catch (error) {
      setIsPlandetailsLoading(false);
    }
  }

  const getGroupList = async (isUpdate = false, groupId) => {
    try {
      let params = {
        IsUpdate: isUpdate,
        GroupId: groupId ? groupId : ''
      }
      const { data } = await GetAllGroupListApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setGroups(data?.data?.map((item) => ({ ...item, value: item?.id, label: item?.name })));
      }
    } catch (error) { }
  }

  const getGroupPlanName = async (isUpdate = false, groupId) => {
    try {
      let params = {
        IsUpdate: isUpdate,
        ...(groupId && { GroupId: groupId }),
      }
      const { data } = await GetGroupPlanNameApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setGroupPlanName(data?.data?.map((item) => ({ ...item, value: item?.groupId, label: item?.groupName })));
      }
    } catch (error) { }
  }

  useEffect(() => {
    if (selectedPlan?.planId) {
      getActivePlan();
    }
  }, [selectedPlan]);

  useEffect(() => {
    getAllPlan();
  }, [page, pageSize]);

  useEffect(() => {
    if (!isOpenPlanModal) {
      form.resetFields();
      setInitialValues({ planName: '', groupId: null, minimumDeposit: '', instruments: '', spread: '', commission: '', v2fx: null, swapFree: null, marginCall: '', stopOut: '', tradingAccountType: null, isActive: true });
      setIsEdit(false);
    }
    if (!openCreateGroupModal) {
      createGroupForm.resetFields();
      setCreateGroupInitValues({ name: '', userName: '', email: '', password: '', isReadOnly: true, phone: '', address: '', forceChangePassword: true });
    }
  }, [isOpenPlanModal, openCreateGroupModal]);

  const updatePlanHandler = (plan) => {
    form.setFieldsValue({
      tradingAccountType: plan?.tradingAccountType === 'Live' ? 0 : 1,
      leverage: plan?.leverage,
      commission: plan?.commission,
      instruments: plan?.instruments,
      marginCall: plan?.marginCall,
      minimumDeposit: plan?.minimumDeposit,
      spread: plan?.spread,
      stopOut: plan?.stopOut,
      planName: plan?.planName,
      groupId: plan?.groupId,
      swapFree: plan?.swapFree,
      groupCommission: plan?.groupCommission,
      isActive: plan?.isActive
    });
    // getGroupList(true, plan?.groupId);
    getGroupPlanName(true, plan?.groupId);
    setIsEdit(true);
    setIsFormChanged(false);
    setIsOpenPlanModal(true);
  }

  const handleSubmit = async (values) => {
    setIsSubmitLoading(true);
    let params = {
      ...values,
      commission: Number(values.commission),
      instruments: Number(values.instruments),
      marginCall: Number(values.marginCall),
      minimumDeposit: Number(values.minimumDeposit),
      spread: Number(values.spread),
      stopOut: Number(values.stopOut),
    };
    try {
      if (isEdit) {
        const { data } = await AddUpdatePlanApi({ planId: selectedPlan?.planId, ...params });
        if (data?.success) {
          toast.success(data?.message);
          setIsOpenPlanModal(false);
          getAllPlan();
          setIsEdit(false);
          form.resetFields();
        }
      } else {
        const { data } = await AddUpdatePlanApi(params);
        if (data?.success) {
          toast.success(data?.message);
          setIsOpenPlanModal(false);
          getAllPlan();
          form.resetFields();
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'An error occurred');
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const openAddPlanModal = () => {
    // getGroupList(false);
    getGroupPlanName(false);
    form.resetFields();
    setInitialValues({ planName: '', groupId: null, minimumDeposit: '', instruments: '', spread: '', commission: '', v2fx: null, swapFree: null, marginCall: '', stopOut: '', tradingAccountType: null, isActive: true });
    setIsFormChanged(true);
    setIsOpenPlanModal(true);
    setIsEdit(false);
  }

  const SyncGroups = async () => {
    try {
      setIsSync(true);
      const { data } = await SyncGroupsApi();
      if (data?.success) {
        toast.success(data?.message);
      }
      setIsSync(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setIsSync(false);
    }
  }

  const handleCreateGroup = async (values) => {
    setIsSubmitLoading(true);
    try {
      const { data } = await CreateGroupApi(values);
      if (data?.success) {
        toast.success(data?.message);
        setOpenCreateGroupModal(false);
        createGroupForm.resetFields();
        getAllPlan();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'An error occurred');
    } finally {
      setIsSubmitLoading(false);
    }
  }

  return (
    <div>
      <div className="flex justify-end items-center flex-wrap gap-3">
        <div className="flex gap-3">
          <LoadableButton type='button' onClick={SyncGroups} className='bg-primary text-sm text-white font-medium rounded-lg px-6 py-2 themeHover duration-500'
            lable='Sync Groups' isLoading={isSync} loadingLable='Sync Groups...' />
          <button onClick={openAddPlanModal} className="flex items-center bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover  duration-500">
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" className="mr-2" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.85714 9.14286H0V6.85714H6.85714V0H9.14286V6.85714H16V9.14286H9.14286V16H6.85714V9.14286Z" fill="white" />
            </svg>
            Add Plan
          </button>
        </div>
        <div>
          <button onClick={e => setOpenCreateGroupModal(true)} className="flex items-center bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover  duration-500">
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" className="mr-2" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.85714 9.14286H0V6.85714H6.85714V0H9.14286V6.85714H16V9.14286H9.14286V16H6.85714V9.14286Z" fill="white" />
            </svg>
            Create Group
          </button>
        </div>
      </div>

      <div className="my-6">
        <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
          <TableWithSkeleton
            columns={columns}
            data={data}
            loading={isLoading}
            page={page}
            pageSize={pageSize}
          />
        </div>
        <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
      </div>

      {/* ---- Add update plan ---- */}
      <ModalComponent isOpen={isOpenPlanModal} setIsOpen={setIsOpenPlanModal} title={isEdit ? 'Update Plan' : 'Add Plan'} width={1300}>
        <Form className='w-full' autoComplete="off" form={form} initialValues={initialValues} onFinish={handleSubmit} onFieldsChange={handleFieldsChange}>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Plan Name</label>
              <Form.Item name="planName" rules={[{ required: true, message: 'Please enter Plan name.' }]}>
                <Input placeholder="Plan name" className="mt-1 w-full ps-4 py-2" />
              </Form.Item>
            </div>
            <div className="ant-select-selector-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Group Name</label>
              <Form.Item name="groupId" rules={[{ required: true, message: 'Please select group name.' }]}>
                <Select placeholder="Select a group name" className="w-full mt-1" options={groupPlanName} />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Minimum Deposit</label>
              <Form.Item name="minimumDeposit" rules={[{ required: true, message: 'Please enter minimum deposit.' }]}>
                <Input type="number" placeholder="Minimum deposit" className="mt-1 w-full ps-4 py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Instruments</label>
              <Form.Item name="instruments" rules={[{ required: true, message: 'Please enter instruments.' }]}>
                <Input type="number" placeholder="Instruments" className="mt-1 w-full ps-4 py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Spread</label>
              <Form.Item name="spread" rules={[{ required: true, message: 'Please enter Spread.' }]}>
                <Input type="number" placeholder="Spread" className="mt-1 w-full ps-4 py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">IB Commission</label>
              <Form.Item name="commission" rules={[{ required: true, message: 'Please enter commission.' }]}>
                <Input type="number" placeholder="IB Commission" className="mt-1 w-full ps-4 py-2" />
              </Form.Item>
            </div>
            <div className="ant-select-selector-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Leverage</label>
              <Form.Item name="leverage" rules={[{ required: true, message: 'Please Select leverage.' }]}>
                <Select placeholder="Select leverage" className="w-full mt-1" options={[{ value: "100", label: "100" }, { value: "200", label: "200" }, { value: "300", label: "300" }, { value: "400", label: "400" }, { value: "500", label: "500" }]} />
              </Form.Item>
            </div>
            <div className="ant-select-selector-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Swap Free</label>
              <Form.Item name="swapFree" rules={[{ required: true, message: 'Please Select swap free.' }]}>
                <Select placeholder="Select swap free" className="w-full mt-1" options={[{ value: true, label: "Yes" }, { value: false, label: "No" }]} />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Margin Call</label>
              <Form.Item name="marginCall" rules={[{ required: true, message: 'Please enter margin call.' }]}>
                <Input type="number" placeholder="Margin call" className="mt-1 w-full ps-4 py-2" />
              </Form.Item>
            </div>
            <div className="ant-select-selector-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Account Type</label>
              <Form.Item name="tradingAccountType" rules={[{ required: true, message: 'Please Select account type.' }]}>
                <Select placeholder="Account type" className="w-full mt-1" options={[{ value: 0, label: "Live" }, { value: 1, label: "Demo" }]} />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Stop Out</label>
              <Form.Item name="stopOut" rules={[{ required: true, message: 'Please enter Stop out.' }]}>
                <Input type="number" placeholder="Stop out" className="mt-1 w-full ps-4 py-2" />
              </Form.Item>
            </div>
            {groupCommissionOptions?.length == 0 ? (
              <div className="input-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Group Commission</label>
                <Form.Item name="groupCommission" rules={[{ required: true, message: 'Please enter group commission.' }]}>
                  <Input type="number" placeholder="Enter group commission" className="mt-1 w-full ps-4 py-2" />
                </Form.Item>
              </div>) : (
              <div className="ant-select-selector-white">
                <label className="text-base text-[#2F2B3DCC] font-medium">Group Commission</label>
                <Form.Item name="groupCommission" rules={[{ required: true, message: 'Please select group commission.' }]}>
                  <Select placeholder="Select group commission" className="w-full mt-1" options={groupCommissionOptions} />
                </Form.Item>
              </div>
            )}
            <div className="ant-select-selector-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Status</label>
              <Form.Item name="isActive" rules={[{ required: true, message: 'Please Select account status.' }]}>
                <Select placeholder="Select account status" className="w-full mt-1" options={[{ value: true, label: "Active" }, { value: false, label: "Inactive" }]} />
              </Form.Item>
            </div>
          </div>
          <div className="flex justify-between items-center mt-7 gap-5">
            <button type="button" onClick={() => setIsOpenPlanModal(false)} className="bg-primary text-sm text-white font-medium uppercase px-10 py-2 rounded-lg hover:bg-primary duration-500">Back</button>
            <LoadableButton type='submit' className='bg-primary text-sm text-white font-medium uppercase px-10 py-2 rounded-lg hover:bg-primary duration-500' lable='Submit' disabled={!isFormChanged || isSubmitLoading} isLoading={isSubmitLoading} loadingLable='Submitting...' />
          </div>
        </Form>
      </ModalComponent>

      {/* ---- Plan Information ---- */}
      <ModalComponent
        isOpen={isOpenModal}
        setIsOpen={setIsOpenModal}
        onCancel={() => setIsOpenModal(false)}
        width={400}
      >

        <div>
          {isPlandetailsLoading ? (
            <div className="flex justify-center flex-col my-[45%]">
              <Spin size="large" />
              <p className="primary text-center mt-2">Loading...</p>
            </div>
          ) : (
            <div className="border border-primary rounded-lg px-4 py-3">
              <p className="uppercase text-center text-[#413079] font-semibold text-4xl">
                {activePlanDetails?.planName}
              </p>
              <div className="flex justify-between items-center mt-6">
                <div className="flex items-center">
                  <img
                    src="assets/icons/checkmark-green.svg"
                    width={22}
                    alt="icon"
                  />
                  <p className="text-xl	font-medium text-[#413079] ml-2">
                    Minimum Deposit
                  </p>
                </div>
                <p className="text-xl	font-medium text-[#413079] ml-2">$ {activePlanDetails?.minimumDeposit}</p>
              </div>
              <div className="flex justify-between items-center mt-3">
                <div className="flex items-center">
                  <img
                    src="assets/icons/checkmark-green.svg"
                    width={22}
                    alt="icon"
                  />
                  <p className="text-xl	font-medium text-[#413079] ml-2">
                    Instruments
                  </p>
                </div>
                <p className="text-xl	font-medium text-[#413079] ml-2">{activePlanDetails?.instruments} +</p>
              </div>
              <div className="flex justify-between items-center mt-3">
                <div className="flex items-center">
                  <img
                    src="assets/icons/checkmark-green.svg"
                    width={22}
                    alt="icon"
                  />
                  <p className="text-xl	font-medium text-[#413079] ml-2">
                    Spread From
                  </p>
                </div>
                <p className="text-xl	font-medium text-[#413079] ml-2">{activePlanDetails?.spread} Pips</p>
              </div>
              <div className="flex justify-between items-center mt-3">
                <div className="flex items-center">
                  <img
                    src="assets/icons/checkmark-green.svg"
                    width={22}
                    alt="icon"
                  />
                  <p className="text-xl	font-medium text-[#413079] ml-2">
                    Commission
                  </p>
                </div>
                <p className="text-xl	font-medium text-[#413079] ml-2">$ {activePlanDetails?.groupCommission}</p>
              </div>
              <div className="flex justify-between items-center mt-3">
                <div className="flex items-center">
                  <img
                    src="assets/icons/checkmark-green.svg"
                    width={22}
                    alt="icon"
                  />
                  <p className="text-xl	font-medium text-[#413079] ml-2">
                    Swap free/Islamic
                  </p>
                </div>
                <p className="text-xl	font-medium text-[#413079] ml-2 uppercase">
                  {activePlanDetails?.swapFree === true ? "Yes" : "NO"}
                </p>
              </div>
              <div className="flex justify-between items-center mt-3">
                <div className="flex items-center">
                  <img
                    src="assets/icons/checkmark-green.svg"
                    width={22}
                    alt="icon"
                  />
                  <p className="text-xl	font-medium text-[#413079] ml-2">
                    Margin Call
                  </p>
                </div>
                <p className="text-xl	font-medium text-[#413079] ml-2">{activePlanDetails?.marginCall} %</p>
              </div>
              <div className="flex justify-between items-center mt-3">
                <div className="flex items-center">
                  <img
                    src="assets/icons/checkmark-green.svg"
                    width={22}
                    alt="icon"
                  />
                  <p className="text-xl	font-medium text-[#413079] ml-2">
                    Stop Out
                  </p>
                </div>
                <p className="text-xl	font-medium text-[#413079] ml-2">{activePlanDetails?.stopOut} %</p>
              </div>
              {/* <div className="flex justify-center mt-8 mb-4">
              <button
                onClick={handleSubmit}
                className="bg-primary text-sm text-white font-semibold px-9 py-2 rounded-lg themeHover  duration-500"
              >
                Open Demo Account
              </button>
            </div> */}
            </div>
          )}
        </div>

      </ModalComponent>

      {/* create group modal */}
      <ModalComponent isOpen={openCreateGroupModal} setIsOpen={setOpenCreateGroupModal} title='Create Group' width={1300}>
        <Form className='w-full' autoComplete="off" form={createGroupForm} initialValues={createGroupInitValues} onFinish={handleCreateGroup} >
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Name</label>
              <Form.Item name="name" rules={[{ required: true, message: 'Please enter name.' }]}>
                <Input placeholder="Name" className="mt-1 w-full ps-4 py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Username</label>
              <Form.Item name="userName" rules={[{ required: true, message: 'Please enter username.' }]}>
                <Input placeholder="Username" className="mt-1 w-full ps-4 py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Email</label>
              <Form.Item name="email" rules={[{ required: true, message: 'Please enter email.' }]}>
                <Input type="email" placeholder="Email" className="mt-1 w-full ps-4 py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Password</label>
              <Form.Item name="password" rules={[{ required: true, message: 'Please enter password.' }]}>
                <Input.Password placeholder="Password" className="mt-1 w-full ps-4 py-2" />
              </Form.Item>
            </div>
            <div className="ant-select-selector-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Read-Only</label>
              <Form.Item name="isReadOnly" rules={[{ required: true, message: 'Please select read-only status.' }]}>
                <Select
                  placeholder="Select read-only status"
                  className="w-full mt-1"
                  options={[{ value: true, label: "Yes" }, { value: false, label: "No" }]}
                />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Phone</label>
              <Form.Item name="phone" rules={[{ required: true, message: 'Please enter phone number.' }]}>
                <Input placeholder="Phone" className="mt-1 w-full ps-4 py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Address</label>
              <Form.Item name="address" rules={[{ required: true, message: 'Please enter address.' }]}>
                <Input placeholder="Address" className="mt-1 w-full ps-4 py-2" />
              </Form.Item>
            </div>
            <div className="ant-select-selector-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">Force Change Password</label>
              <Form.Item name="forceChangePassword" rules={[{ required: true, message: 'Please select force change password option.' }]}>
                <Select
                  placeholder="Select force change password option"
                  className="w-full mt-1"
                  options={[{ value: true, label: "Yes" }, { value: false, label: "No" }]}
                />
              </Form.Item>
            </div>
          </div>
          <div className="flex justify-between items-center mt-7 gap-5">
            <button
              type="button"
              onClick={() => setOpenCreateGroupModal(false)}
              className="bg-primary text-sm text-white font-medium uppercase px-10 py-2 rounded-lg hover:bg-primary duration-500"
            >
              Back
            </button>
            <LoadableButton
              type='submit'
              className='bg-primary text-sm text-white font-medium uppercase px-10 py-2 rounded-lg hover:bg-primary duration-500'
              lable='Submit'
              disabled={isSubmitLoading}
              isLoading={isSubmitLoading}
              loadingLable='Submitting...'
            />
          </div>
        </Form>
      </ModalComponent>

      {/* ---- Status chnage confirmation modal ---- */}
      <ConfirmationModal
        isOpen={isStatusConfirmOpen}
        setIsOpen={setIsStatusConfirmOpen}
        message='Are you sure to change the plan status?'
        onConfirm={statusChangeConfirm}
        isLoading={isStatusConfirmLoading}
        loadingLabel='Changing status...'
      />

    </div>
  );
}
